<template>
  <div class="course-outline">
    <a-collapse
      v-model="activeKey"
      expandIconPosition="right"
      :bordered="false"
    >
      <template #expandIcon="props">
        <img
          src="@/assets/img/icon/icon8.png"
          alt=""
          :class="{ active: props.isActive }"
        />
      </template>
      <a-collapse-panel
        v-for="el in outlineInfo"
        :key="el.id"
        :header="el.chapterName"
        class="section"
        :show-arrow="false"
      >
        <OutlineNode :info="el.children" />
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import OutlineNode from "./outlineNode.vue";
import { courseChapterTree } from "@/api/activity";

export default {
  components: {
    OutlineNode,
  },
  data() {
    return {
      outlineInfo: [],
      activeKey: [],
    };
  },
  computed: {
    id: function () {
      return this.$route.query.id;
    },
  },
  watch: {
    id: function () {
      this.loadInfo();
    },
  },
  mounted() {
    this.loadInfo();
  },
  methods: {
    loadInfo() {
      courseChapterTree({ courseId: this.id }).then((res) => {
        this.outlineInfo = res;
        if (res.length > 0) {
          res.forEach((element) => {
            this.activeKey.push(element.id);
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.course-outline {
  padding: 24px;
  ::v-deep .ant-collapse {
    background-color: transparent;
    .active {
      transform: translateY(-50%) rotate(180deg);
    }
    .ant-collapse-header {
      padding: 17px 16px;
      margin-bottom: 8px;
    }
    .ant-collapse-content-box {
      padding: 0;
    }
    .section {
      > .ant-collapse-header {
        background: #f6f7fb;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        color: #262626;
        line-height: 22px;
      }
    }
    > .ant-collapse-item {
      border-bottom: 0;
    }
    .ant-collapse-borderless {
      background-color: transparent;
    }
  }
}
</style>
